import type { SVGProps } from 'react';
const SvgAngleDownSharp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" {...props}>
    <path d="m224 385.9 17-17L401 209l17-17-34-33.9-17 17-143 143L81 175l-17-17-33.9 34 17 17L207 369l17 17z" />
  </svg>
);
export default SvgAngleDownSharp;
